/** Human-readable admin timestamp, e.g. Sep 10, 2026, 3:19 PM */
export function formatAdminDateTime(
  value: string | Date | undefined | null,
  timeZone?: string
): string {
  if (!value) {
    return '—';
  }
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return String(value);
  }
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    timeZone: timeZone || undefined
  }).format(date);
}

export function competitionTimeZone(competition?: { timezone?: string } | null): string | undefined {
  const tz = competition && competition.timezone;
  return tz && tz.trim() ? tz.trim() : undefined;
}
